// READ (fast, no network)
export function getCsrfToken(): string {
    return document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') ?? '';
}

// FETCH (only when needed)
let csrfPromise: Promise<string> | null = null;

export async function refreshCsrfToken(): Promise<string> {
    if (!csrfPromise) {
        csrfPromise = fetch('/refresh-csrf', {
            headers: {
                Accept: 'application/json',
            },
        })
            .then(async (res) => {
                if (!res.ok) throw new Error('Failed to refresh CSRF');
                return res.json();
            })
            .then((data) => {
                const meta = document.querySelector('meta[name="csrf-token"]');
                if (meta) meta.setAttribute('content', data.csrfToken);
                return data.csrfToken;
            })
            .finally(() => {
                csrfPromise = null;
            });
    }

    return csrfPromise;
}
